export function clearLS() {
    let lsLength = localStorage.length;
    let index = 0
    while (index < lsLength + 1) {
        const itemKey = localStorage.key(index);
        console.log(itemKey)
        if (
            itemKey.toLowerCase().indexOf('lastdatasets') !== -1
            || itemKey.toLowerCase().indexOf('tableedit') !== -1
            || itemKey.toLowerCase().indexOf('tablescroll') !== -1
        ) {
            localStorage.removeItem(itemKey);
            lsLength -= 1;
        }
        else index += 1;
    }
}